











import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AppToolbar from '@/components/AppToolbar.vue'
import AppDrawer from '@/components/AppDrawer.vue'
import { IS_USER_LOGGED_IN } from '@/store/getter-types'
import { Getter } from 'vuex-class'
import '../node_modules/ag-grid-community/dist/styles/ag-grid.css'
import '../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css'
import '../node_modules/ag-grid-community/dist/styles/ag-theme-material.css'

@Component({
  components: {
    AppToolbar,
    AppDrawer
  }
})
export default class App extends Vue {
  @Getter(IS_USER_LOGGED_IN) isUserLoggedIn!: boolean

  get showAppToolbar (): boolean {
    return this.isUserLoggedIn
  }

  get showAppDrawer (): boolean {
    return this.isUserLoggedIn
  }
}
